





















import Vue from 'vue';
import { Logo, Button } from '@descomplica/vue-components';
import VIEWS_NAMES from '@/router/viewsNames';

export default Vue.extend({
  components: {
    Logo,
    Button,
  },
  props: {
    alreadyStartedAdmissionButton: {
      type: Boolean,
      default: false,
    },
    notStartedAdmissionButton: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    navigateToSignIn() {
      this.$router.push({ name: VIEWS_NAMES.SIGN_IN });
    },
    navigateToSignUp() {
      this.$router.push({ name: VIEWS_NAMES.SIGN_UP });
    },
  },
});
